import { render, staticRenderFns } from "./BlockUserController.vue?vue&type=template&id=6d610551&"
import script from "./BlockUserController.vue?vue&type=script&lang=ts&"
export * from "./BlockUserController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports